'use strict';
import React from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';
import {Button} from '../../../../components/buttons/Button';
import {I18nMessage} from '../../../../components/I18nMessage';
import {AppNavigationLayout} from '../../../../components/views/AppNavigationLayout';
import {ProjectList} from '../../../../projects/components/ProjectList';
import {AppNavigationProjectsFilter} from './AppNavigationProjectsFilter';


export function AppNavigationProjectsView(props) {
  return (
    <AppNavigationLayout
      className={classNames("AppNavigationProjects", props.className)}
      showBack={true}
      onClickBack={props.onClickBack}
      headerLabelContent={(
        <div>
          <span className="AppNavigationProjects__ancestorName">
            {props.organizationName}
          </span>
          <span className="AppNavigationProjects__divider">
            {'/'}
          </span>
          <span className="AppNavigationProjects__headerLabel">
            <I18nMessage message="projects.nav.banner.title" />
          </span>
        </div>
      )}
      headerDescriptionContent={<I18nMessage message="projects.nav.banner.description" />}
      filterComponent={<AppNavigationProjectsFilter parentId={props.parentId} />}
      viewHeaderContent={
        <div className="AppNavigationProjects__headerRightButtons">
          <Button
            className="AppNavigationProjects__headerButton"
            activeClassName="AppNavigationProjects__headerButton_active"
            iconClass="context-icon"
            onClick={props.onClickOptions}
          />
        </div>
      }
      onLoadMore={props.onLoadMore}
      mode={props.mode}
    >
      <ProjectList
        className="AppNavigationProjects__list"
        useScroll={false}
        userId={props.userId}
        list={props.list}
        mode={props.mode}
        hasMore={props.hasMore}
        onClickItem={props.onClickItem}
        onItemShowOptions={props.onItemShowOptions}
      />
    </AppNavigationLayout>
  );
}

AppNavigationProjectsView.propTypes = {
  className: T.string,
  organizationName: T.string,
  onClickBack: T.func,
  onClickItem: T.func,
  onItemShowOptions: T.func,
};



// WEBPACK FOOTER //
// ./src/js/app/navigation/components/AppNavigationProjects/AppNavigationProjectsView.js